<script setup lang="ts">
import type { EstateType } from '~/types/EstateType'
import type { Benefit } from '~/types/api/EstateDetail'

const props = defineProps<{
  item: Benefit
  estateType: EstateType
}>()

const imageData = getImageSrcSizesData(props.item.image, {
  defaultFormat: '50x100',
  sizes: '50px',
})
</script>

<template>
  <div class="c-estate-equipment-item">
    <img
      class="c-estate-equipment-item__image"
      :src="imageData.src"
      :sizes="imageData.sizes"
      :srcset="imageData.srcset"
      loading="lazy"
    />
    <div class="c-estate-equipment-item__name">
      {{ item.name }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@inkline/inkline/css/mixins' as *;

.c-estate-equipment-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 16px 24px;
  background-color: var(--color-solid-grey);

  @include breakpoint-down('sm') {
    padding: 14px 16px;
  }

  &__image {
    flex: 0 0 auto;
    width: 50px;
    height: 50px;
    min-height: 0;
    object-fit: contain;
  }

  &__name {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    line-height: 1.1;
  }
}
</style>
